<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-6">
        <help-text>
          <h3>
            Create Ad Format
          </h3>

          <p>
            Enter the details of the ad format.
          </p>
        </help-text>
      </div>

      <div class="col-xs-18">
        <div class="panel panel-default">
          <div class="panel-body">
            <form @submit.prevent="submit" class="form-horizontal">
              <TextFormGroup
                  v-model="data.name"
                  name="name"
                  label="Name"
                  :error="getError('name')"
              />

              <TextareaFormGroup
                  v-model="data.description"
                  name="description"
                  label="Marketing Site Description"
                  :error="getError('description')"
              />

              <CkEditorFormGroup
                  v-model="data.partner_description"
                  name="partner_description"
                  label="Partner CMS Description"
                  :error="getError('partner_description')"
              />

              <TextFormGroup
                  v-model="data.location"
                  name="location"
                  label="Location"
                  :error="getError('location')"
              />

              <NumberFormGroup
                  v-model="data.price_per_day"
                  name="price_per_day"
                  label="Price Per Day"
                  help-text="The price per day of the ad format."
                  :error="getError('price_per_day')"
              />

              <RadioFormGroup
                  v-model="data.send_content_reminders"
                  name="send_content_reminders"
                  label="Send Content Reminders"
                  help-text="Send content reminders for this ad format."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('send_content_reminders')"
              />

              <RadioFormGroup
                  v-model="data.is_advertised"
                  name="is_advertised"
                  label="Is Advertised"
                  help-text="Advertise the ad format on the marketing site."
                  :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
                  :error="getError('is_advertised')"
              />

              <TechnicalDescriptionsFormGroup
                  v-model="data.technical_descriptions"
                  :errors="errors"
              />

              <GalleryFormGroup
                  v-model="data.image_id"
                  name="image_id"
                  label="Image"
                  :error="getError('image_id')"
                  :nullable="true"
              />

              <GalleryFormGroup
                  v-model="data.example_image_id"
                  name="example_image_id"
                  label="Example Image"
                  :error="getError('example_image_id')"
                  :nullable="true"
              />

              <hr>

              <SubmitFormGroup button-class="btn-black"/>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import CkEditorFormGroup from '@/vendor/forms/FormGroups/Horizontal/CkEditor'
import Errors from '@/mixins/Errors'
import GalleryFormGroup from '@/components/FormGroups/Horizontal/Gallery'
import HelpText from '@/components/HelpText'
import Load from '@/mixins/Load'
import NumberFormGroup from '@/vendor/forms/FormGroups/Horizontal/Number'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
import TechnicalDescriptionsFormGroup from '@/components/FormGroups/Horizontal/TechnicalDescriptions'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Horizontal/Textarea'
import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

export default {
  components: {
    CkEditorFormGroup,
    GalleryFormGroup,
    HelpText,
    NumberFormGroup,
    RadioFormGroup,
    SubmitFormGroup,
    TechnicalDescriptionsFormGroup,
    TextareaFormGroup,
    TextFormGroup
  },

  mixins: [Errors, Load],

  model: {
    prop: 'portal',
    event: 'portal-updated'
  },

  props: ['portal', 'timeBasedChannelId', 'timeBasedSubchannelId'],

  data() {
    return {
      data: {
        technical_descriptions: []
      }
    }
  },


  methods: {
    submit() {
      http.post('/api/v2/time-based-ad-formats', {
        ...this.data,
        time_based_subchannel_id: this.timeBasedSubchannelId
      })
          .then(() => {
            notify.success('The ad format was saved')

            this.$router.push('/portals/' + this.portal.id + '/time-based-channels/' + this.timeBasedChannelId + '/time-based-subchannels/' + this.timeBasedSubchannelId)
          })
          .catch(this.catchValidationErrors)
    }
  }
}
</script>
